/* Scroll parallax on .am-section-overlay via --am-parallax-y */
(function () {
  var STRENGTH = 0.4;
  var MAX_SHIFT_PX = 100;
  var ticking = false;
  var started = false;
  var overlays = [];

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function collectOverlays() {
    overlays = Array.prototype.slice.call(
      document.querySelectorAll('.am-section-overlay')
    );
  }

  function getAnchor(overlay) {
    return (
      overlay.closest('.am-section-overlay-stage') ||
      overlay.closest('.am-shoppable-image__stage') ||
      overlay.closest('[data-am-section-overlay-root]')
    );
  }

  function updateOverlay(overlay) {
    var anchor = getAnchor(overlay);
    if (!anchor) return;

    var rect = anchor.getBoundingClientRect();
    var centerY = rect.top + rect.height * 0.5;
    var offsetY = (window.innerHeight * 0.5 - centerY) * STRENGTH;
    offsetY = Math.max(-MAX_SHIFT_PX, Math.min(MAX_SHIFT_PX, offsetY));

    overlay.style.setProperty('--am-parallax-y', offsetY + 'px');
  }

  function updateAll() {
    overlays.forEach(updateOverlay);
    ticking = false;
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function bindScroll() {
    if (started) return;
    started = true;
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
  }

  function start() {
    if (prefersReducedMotion()) return;

    collectOverlays();
    if (!overlays.length) return;

    bindScroll();
    updateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', start);

  document.addEventListener('shopify:section:load', function () {
    started = false;
    start();
  });
})();
